import React from 'react'
import { useParams } from 'react-router-dom'
import { useEffect } from 'react'
import { searchCourses } from '../services/operations/courseDetailsAPI'
import { useState } from 'react'
import CatalogCard from '../components/core/Catalog/Course_Card'
import { useDispatch } from 'react-redux'
import {HiOutlineEmojiSad} from 'react-icons/hi'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import "react-loading-skeleton/dist/skeleton.css";

const SearchCourse = () => {
    const [searchResults, setSearchResults] = useState([]);
    const [loading, setLoading] = useState(false);
    const distpatch= useDispatch();
    const {searchQuery}=useParams();
    const fetchSearchResults= async ()=>{
        setLoading(true);
        const res = await searchCourses(searchQuery,distpatch);
        setSearchResults(res);
        setLoading(false);
        console.log(res);
    }

    useEffect(() => {
        fetchSearchResults();
    }, [searchQuery])




  return (
    <div className=''>
        <div className='mx-auto flex min-h-[260px]  flex-col justify-center gap-4 p-5 bg-pure-greys-150'>
        <p className='text-md text-richblack-600'>Home / Search / <span className='text-blue-200'>{searchQuery}</span> </p>
        <p className='text-3xl text-richblack-600'>Search Results for {searchQuery}</p>
      
        <p className='max-w-[870px] text-pink-200'>
            {searchResults?.length} results found for {searchQuery}
        </p>
        </div>
        {
            loading ? (
                 <div className="grid place-items-center mt-10">
              <div className="spinner"></div>
            </div>
            ):

            searchResults?.length===0 ? (<div className='mx-auto flex min-h-[500px] items-center  flex-col justify-center gap-4 p-5 bg-pure-greys-250 '>
                <p className='text-3xl text-richblack-800'>No Results Found</p>
                <HiOutlineEmojiSad className=' text-richblack-400 text-[100px]' />
            </div>):
            (
                <div className='mx-auto flex flex-wrap p-5 gap-4 justify-evenly m-5 '>
                {searchResults?.map((item)=>(
                    <div className='flex flex-col gap-4'>
                    <CatalogCard course={item} Height={"lg:h-[250px] h-[100px]"} />
                    </div>
                ))}
                </div>
            )
        }
       
            
    </div>
  )
}

export default SearchCourse
